import { render, staticRenderFns } from "./CapacitorBooks.vue?vue&type=template&id=4205699c&"
import script from "./CapacitorBooks.vue?vue&type=script&lang=js&"
export * from "./CapacitorBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports